export default {
  CONSTRUCT() {
    return {
      visible: false,
      message: '',
      x: 0,
      y: 0
    };
  },
  SHOW_TOOLTIP(state, data) {
    return state.set('visible', true).set('message', data.message).set('x', data.x).set('y', data.y);
  },
  HIDE_TOOLTIP(state) {
    return state.set('visible', false);
  }
};
